import { DocsEntityType } from "../../enums/SDKDocsEntityType";
import { DocsEntity } from "./SDKDocsEntity";
import { DocsEntityApprovalState } from "./SDKDocsEntityApprovalState";
import { DocsEntityConfiguration } from "./SDKDocsEntityConfiguration";
import { DocsEntityDraftState } from "./SDKDocsEntityDraftState";
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class DocsEntityPage extends DocsEntity {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        super(model);
        this.deployedUrl = null;
        this.relativeUrl = null;
        this.editorUrl = null;
        this.roomId = null;
        this.relativeUrl = (_a = model.path) !== null && _a !== void 0 ? _a : null;
    }
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Convenience
    /** Internal: Modifies object with new paths. Don't use outside SDK environment as it doesn't propagate the data back to source */
    internalOverridePaths(deployed, editor, relative) {
        this.editorUrl = editor;
        this.deployedUrl = deployed;
        this.relativeUrl = relative;
    }
    /** Retrieve editor page URL that can be opened */
    editorPageUrl() {
        return this.editorUrl;
    }
    /** Retrieve documentation page URL, if the documentation was already deployed (either default or custom domain) */
    deployedPageUrl() {
        return this.deployedUrl;
    }
    /** Retrieve relative page path without the associated domain. Will work even when documentation was not yet deployed */
    relativePageUrl() {
        return this.relativeUrl;
    }
}
/** Lightweight page representation used in multiplayer context type-validated against the full version */
export class DocsEntityMultiplayerPage {
    constructor(model) {
        var _a, _b, _c, _d, _e;
        this.isTab = null;
        this.persistentId = model.persistentId;
        this.type = DocsEntityType.page;
        this.title = model.title;
        this.relativeUrl = (_a = model.path) !== null && _a !== void 0 ? _a : null;
        this.createdAt = model.createdAt ? new Date(model.createdAt) : null;
        this.parentId = null;
        this.parent = null;
        this.isPrivate = Boolean((_b = model.configuration) === null || _b === void 0 ? void 0 : _b.isPrivate);
        this.isHidden = Boolean((_c = model.configuration) === null || _c === void 0 ? void 0 : _c.isHidden);
        this.draftState = model.draftState
            ? new DocsEntityDraftState(model.draftState)
            : null;
        this.approvalState = new DocsEntityApprovalState(model.approvalState || null, this.draftState);
        this.configuration = model.configuration
            ? new DocsEntityConfiguration(model.configuration, model.title)
            : null;
        this.roomId = (_d = model.liveblocksRoomId) !== null && _d !== void 0 ? _d : null;
        this.publishMetadata = (_e = model.publishMetadata) !== null && _e !== void 0 ? _e : null;
        this.configuration = model.configuration
            ? new DocsEntityConfiguration(model.configuration, this.title)
            : null;
    }
}
